<p-card>
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
            <div class="text-end p-0 border-round-sm font-bold">
                <p-button pTooltip="Add Credential" tooltipPosition="left" (click)="show('Add Credential','')"
                    styleClass="customAdd p-button-sm p-button-raised mr-4"
                    icon="fa fa-plus p-button-icon ng-star-inserted"></p-button>
                <button class="fa fa-question helpicon" pTooltip="Help"
                    (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','12')" tooltipPosition="bottom"
                    aria-hidden="true"></button>
            </div>
        </div>
    </div>

    <div class="mr-0 tablehiegt">
        <p-table #dt [value]="dataListArray" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
            [customSort]="customSort" (sortFunction)="this.utilityserv.customSort($event)"
            scrollHeight="{{categoryScrollHeight}}" [globalFilterFields]="['url','userid','createdon','sno']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
            paginatorLocale="fa-IR" [paginator]="true" [sortOrder]="1" responsiveLayout="scroll"
            [first]="currentPageIndex" (onPage)="handlePageChange($event)" sortField="url" [resizableColumns]="true"
            columnResizeMode="expand">
            <ng-template pTemplate="caption">
                <div>
                    <div class="grid table-header">
                        <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                            <span class="p-input-icon-lft">
                                <i icon="pi pi-search"></i>
                                <input class="form-control" pInputText type="text" id="tablesearch"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains'); searchTerm = $any($event.target).value;"
                                    placeholder="Search in My-Credentials" class="tablesearch"
                                    pTooltip="Enter Search Criteria" tooltipPosition="top" />
                            </span>
                        </div>
                        <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
                            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom"
                                (click)="exceDownloadModel()">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 5% !important;">Action</th>
                    <th style="width: 12% !important;" pSortableColumn="sno" pResizableColumn>S No.<p-sortIcon
                            field="sno"></p-sortIcon>
                        <p-columnFilter type="text" field="sno" display="menu"></p-columnFilter>
                    </th>
                    <th pstyle="width: 30% !important;" pSortableColumn="url" pResizableColumn>URL Name <p-sortIcon
                            field="url"></p-sortIcon>
                        <p-columnFilter type="text" field="url" display="menu"></p-columnFilter>
                    </th>
                    <th style="width: 30% !important;" pSortableColumn="userid" pResizableColumn>User ID <p-sortIcon
                            field="userid"></p-sortIcon>
                        <p-columnFilter type="text" field="userid" display="menu"></p-columnFilter>
                    </th>
                    <th style="width: 15% !important;" pSortableColumn="createdon" pResizableColumn>Created On
                        <p-sortIcon field="createdon"></p-sortIcon>
                        <p-columnFilter type="text" field="createdon" display="menu"></p-columnFilter>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-data>
                <tr>
                    <td>
                        <div style="display: flex; gap: 0px;">
                            <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
                                <i class="fa fa-edit" (click)="show('Modify Credential', data)"></i>
                            </span>
                            <span class="actionItm" pTooltip="Delete" tooltipPosition="left">
                                <i class="p-element fa fa-trash-o red-icon" (click)="deleteCredential(data.rid)"
                                    style="cursor: pointer;color: red;"></i>
                            </span>
                        </div>
                    </td>
                    <td pTooltip="{{data.sno}}" tooltipPosition="left"[innerHTML]="highlight(data.sno, searchTerm)">
                    <td pTooltip="{{data.url}}" tooltipPosition="left"[innerHTML]="highlight(data.url, searchTerm)">
                    <td pTooltip="{{data.userid}}" tooltipPosition="left"[innerHTML]="highlight(data.userid, searchTerm)">
                    <td pTooltip="{{data.createdon}}" tooltipPosition="left"[innerHTML]="highlight(data.createdon, searchTerm)">

                    <!-- <td tooltipPosition="left" pTooltip="{{data.sno}}">{{data.sno}}</td>
                    <td tooltipPosition="left" pTooltip="{{data.url}}">{{data.url}}</td>
                    <td tooltipPosition="left" pTooltip="{{data.userid}}">{{data.userid}}</td>
                    <td tooltipPosition="left" pTooltip="{{data.createdon}}">{{data.createdon}}</td> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="dataListArray.length + 5" class="datanotfound" style="text-align: center;">
                        No data available
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>